export default __webpack_public_path__ + "static/media/CafeAvion-3.23c7cebc.jpg";